module.exports = __webpack_public_path__ + "img/logo.4c6a7db0.png";